export default () => ({
  device: null,
  devices: [],
  totalDevices: 0,
  deviceFiles: [],
  deviceFile: null,
  totalDeviceFiles: 0,
  tools: [],
  totalTools: 0,
  toolMakes: [],
  connectedDevices: [],
  currentDevice: null,
  searchTerm: '',
  pageSize: 10,
  sortDir: 'asc',
  orderBy: 'Name',
  status: '',
  filterBy: 0,
  totalFoundDevices: 0,
  foundDevices: [],
  activeTab: 'Device',
  tabs: ['Device', 'Location', 'Shipment'],
  deviceTypes: [],
  assignedDevices: [],
  totalAssignedDevices: 0
})



// WEBPACK FOOTER //
// ./src/store/modules/devices/state.js